import { createStructuredSelector } from 'reselect';
import {
    TASK_VEHICLE_LIST,
    TASK_VEHICLE_LIST_SUCCESS,
    TASK_VEHICLE_LIST_ERROR,
    TASK_VEHICLE_ADD,
    TASK_VEHICLE_ADD_SUCCESS,
    TASK_VEHICLE_ADD_ERROR,
    TASK_VEHICLE_UPDATE,
    TASK_VEHICLE_UPDATE_SUCCESS,
    TASK_VEHICLE_UPDATE_ERROR,
    TASK_VEHICLE_MODAL_SET,
    TASK_VEHICLE_SELECTED_SET
} from '../actions';

export const TaskVehicleList = (data) => ({
    type: TASK_VEHICLE_LIST,
    payload: data
});

export const TaskVehicleListSuccess = (data) => ({
    type: TASK_VEHICLE_LIST_SUCCESS,
    payload: data
});

export const TaskVehicleListError = (error) => ({
    type: TASK_VEHICLE_LIST_ERROR,
    payload: error
});

export const TaskVehicleAdd = (data) => ({
    type: TASK_VEHICLE_ADD,
    payload: data
});

export const TaskVehicleAddSuccess = (data) => ({
    type: TASK_VEHICLE_ADD_SUCCESS,
    payload: data
});

export const TaskVehicleAddError = (error) => ({
    type: TASK_VEHICLE_ADD_ERROR,
    payload: error
});

export const TaskVehicleUpdate = (data) => ({
    type: TASK_VEHICLE_UPDATE,
    payload: data
});

export const TaskVehicleUpdateSuccess = (data) => ({
    type: TASK_VEHICLE_UPDATE_SUCCESS,
    payload: data
});

export const TaskVehicleUpdateError = (error) => ({
    type: TASK_VEHICLE_UPDATE_ERROR,
    payload: error
});

export const TaskVehicleModalSet = (data) => ({
    type: TASK_VEHICLE_MODAL_SET,
    payload: data
});

export const TaskVehicleSelectedSet = (data) => ({
    type: TASK_VEHICLE_SELECTED_SET,
    payload: data
});

const task_vehicle = (state) => state.task_vehicle;

export const TaskVehicleSelector = createStructuredSelector({ task_vehicle });
